// Mirrors VideoProject::ASSET_COPY_* — while in these, the copy's sheet still points at the source.
export const DUPLICATING_STATUSES = ['pending', 'running']

export const ASSET_COPY_PARTIAL = 'partial'
export const ASSET_COPY_FAILED = 'failed'
